import { render, staticRenderFns } from "./ProductListingItem.vue?vue&type=template&id=2418dee4&scoped=true"
import script from "./ProductListingItem.vue?vue&type=script&lang=js"
export * from "./ProductListingItem.vue?vue&type=script&lang=js"
import style0 from "./ProductListingItem.vue?vue&type=style&index=0&id=2418dee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2418dee4",
  null
  
)

export default component.exports